"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  filterKeys: {
    DescKey: 'desc'
  },
  sort: [{
    path: 'desc'
  }],
  stats: false,
  max: 100
};